import styled, { keyframes } from 'styled-components/macro'

import ScrollDownTop from 'assets/scroll-down-top.png'
import ScrollDownMiddle from 'assets/scroll-down-middle.png'
import ScrollDownBottom from 'assets/scroll-down-bottom.png'
import { styleReset } from 'styles/misc'
import { mq } from 'styles/mq'

const pulseDots = keyframes`
  to {
    transform: translateY(-0.5rem);
  }
`

export const Button = styled.button`
  ${styleReset}
  position: relative;
  display: block;
  margin: 5rem auto;
  width: 3.5rem;
  aspect-ratio: 47 / 55;
  cursor: pointer;
  mix-blend-mode: multiply;
  z-index: 5;

  ${mq.large} {
    width: 4.7rem;
  }

  span::before,
  span::after,
  &::after {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: url('${ScrollDownMiddle}') center center / contain no-repeat;
  }

  span {
    &::before,
    &::after {
      animation: 0.6s ${pulseDots} -0.15s infinite alternate;
    }

    &::before {
      animation-delay: -0.3s;
      background-image: url('${ScrollDownTop}');
    }
  }

  &::after {
    animation: 0.6s ${pulseDots} infinite alternate;
    background-image: url('${ScrollDownBottom}');
  }
`
